export default {
      id: "download-usage",
      viewBox: "0 0 13 15",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#download",
      toString: function () {
        return this.url;
      }
    }